const EconomyData = [
    {
        id : "1",
        schemeName: "Make In India ",
        discription:"The scheme was launched on the 25th of September 2014 by the PM, to boost manufacture and infrastructure in India. The initiative stands on the following pillars –Promote entrepreneurship, Upgrade infrastructure, Facilitate investment, Skill development.",
        launchDate: "25 September 2014",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Startup India.",
    discription:"The initiative was announced by the Hon’ble Prime Minister on the 15th of August 2015. It functions under the Ministry of Commerce and Industry of the central government. ",
    launchDate: "15 August 2015",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Standup India",
    discription:"Launched on the 5th of April 2016, the ‘Stand up India’ program is aimed at promoting entrepreneurship among women, scheduled castes and scheduled tribes.",
    launchDate: "5 April 2015",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Skill India",
        discription:"This skill development mission was launched on the 15th of July 2015 to train about 40 Crore Indians so that they contribute better to the economy. The initiatives under this scheme are –Skill loan scheme, Pradhan Mantri Kaushal Vikas Yojana, National Policy for Skill Development and Entrepreneurship, National Skill Development Mission.",
        launchDate: "15 July 2015",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Mudra Yojana",
    discription:"Pradhan Mantri MUDRA Yojana (PMMY) was launched on 8th April 2015, where MUDRA stands for Micro Units Development and Refinance Agency. ",
    launchDate: "8 Aprile 2015", 
     AnualFund: "12345"},
   

 


]
export default EconomyData